'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _voxiReportRow = require('./../voxi-report-row');

var _voxiReportRow2 = _interopRequireDefault(_voxiReportRow);

var _voxiReportTotalsRow = require('./../voxi-report-totals-row');

var _voxiReportTotalsRow2 = _interopRequireDefault(_voxiReportTotalsRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colorMap = {
  instagram: 'pink',
  twitter: 'blue',
  snapchat: 'yellow'
};

var cf = function cf(num) {
  return num ? (0, _numeral2.default)(num).format('0,0') : '-';
};

var imageWrapperStyle = {
  maxHeight: 500,
  overflowY: 'scroll'
};

var bucket = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/';

var ScreenshotModal = function ScreenshotModal(_ref) {
  var modalOpen = _ref.modalOpen,
      selectedPost = _ref.selectedPost,
      closeHandler = _ref.closeHandler;


  if (!selectedPost) return null;

  var supportingData = selectedPost.trackedAsset.supportingData;

  var latestSupportingData = void 0;

  if (supportingData && supportingData.length) {
    console.log(supportingData);
    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
      return o.createdDate;
    }));
    latestSupportingData = ordered[0];
  }

  if (!latestSupportingData) return null;

  var imageSrc = '' + bucket + latestSupportingData.filePath;

  return _react2.default.createElement(
    _semanticUiReact.Modal,
    { size: 'small', open: modalOpen },
    _react2.default.createElement(_semanticUiReact.Header, { icon: 'file image outline', content: 'Supporting screenshot' }),
    _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      _react2.default.createElement(
        'div',
        { style: imageWrapperStyle },
        _react2.default.createElement(_semanticUiReact.Image, { src: imageSrc, size: 'large', bordered: true, centered: true })
      ),
      _react2.default.createElement(
        'h4',
        null,
        'Extracted Data'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table,
        { celled: true, fluid: true, size: 'small', basic: 'very' },
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              'reach'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              cf(latestSupportingData.reach)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              'impressions/views'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              cf(latestSupportingData.views || latestSupportingData.impressions)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              'engagements'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              cf(latestSupportingData.engagements)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              'actions'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              cf(latestSupportingData.actions)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              'clicks'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              cf(latestSupportingData.clicks)
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Actions,
      { style: { textAlign: "center" } },
      _react2.default.createElement(
        _semanticUiReact.Button,
        { color: 'green', onClick: closeHandler, inverted: true },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
        ' Got it'
      )
    )
  );
};

var PlainReport = function (_React$Component) {
  (0, _inherits3.default)(PlainReport, _React$Component);

  function PlainReport() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PlainReport);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = PlainReport.__proto__ || (0, _getPrototypeOf2.default)(PlainReport)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { screenshotModalOpen: false }, _this.toggleScreenshotModal = function (selectedPost) {

      _this.setState({
        screenshotModalOpen: true,
        selectedPost: selectedPost
      });
    }, _this.closeModal = function () {
      _this.setState({
        screenshotModalOpen: false
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PlainReport, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var _state = this.state,
          screenshotModalOpen = _state.screenshotModalOpen,
          selectedPost = _state.selectedPost;
      var posts = data.data.posts;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            singleLine: true,
            celled: true,
            fixed: true,
            basic: 'very',
            size: 'small',
            textAlign: 'center'
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 1 },
                _react2.default.createElement(
                  'span',
                  null,
                  'channel'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                _react2.default.createElement(
                  'span',
                  null,
                  'influencer - asset'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 1 },
                _react2.default.createElement(
                  'span',
                  null,
                  'source'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  width: 1
                },
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(
                    'span',
                    null,
                    'views'
                  ),
                  content: 'sort by views'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 1 },
                _react2.default.createElement(
                  'span',
                  null,
                  'impressions'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 1 },
                _react2.default.createElement(
                  'span',
                  null,
                  'reach'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 1 },
                _react2.default.createElement(
                  'span',
                  null,
                  'actions'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  width: 1
                },
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs up', color: 'grey' }),
                  content: 'sort by number of likes'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  width: 1
                },
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments', color: 'grey' }),
                  content: 'sort by number of comments'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  width: 1
                },
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'share', color: 'grey' }),
                  content: 'sort by number of retweets or shares'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 1 },
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'grey' }),
                    '#ad?'
                  ),
                  content: 'This confirms that the post includes #ad, #spon, #partner'
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _lodash2.default.map(posts, function (post) {
              return _react2.default.createElement(_voxiReportRow2.default, { post: post, toggleScreenshotModalHandler: _this2.toggleScreenshotModal });
            }),
            _react2.default.createElement(_voxiReportTotalsRow2.default, { posts: posts })
          )
        ),
        _react2.default.createElement(ScreenshotModal, { modalOpen: screenshotModalOpen, selectedPost: selectedPost, closeHandler: this.closeModal })
      );
    }
  }]);
  return PlainReport;
}(_react2.default.Component);

;

exports.default = PlainReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/plain-report/index.js
// module id = 1082
// module chunks = 1